import { render, staticRenderFns } from "./SensorDataBrowser.yaml?vue&type=template&id=7022ac20&component"
import script from "./SensorDataBrowser.yaml?vue&type=script&lang=ts&component"
export * from "./SensorDataBrowser.yaml?vue&type=script&lang=ts&component"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports